import { Box } from '@mui/material';
import styled from 'styled-components';

export const CardsGrid = styled(Box)`
  && {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;

    @media (max-width: 999px) {
      grid-template-columns: 1fr;
    }

    @media (min-width: ${({ theme }) =>
        `${theme.breakpoints.values.xl + 1}px`}) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: ${({ theme }) =>
        `${theme.breakpoints.values['2xl']}px`}) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
`;
